<template>
    <div id="cart_section" class="container">
        <div class="row justify-content-center">
            <div class="col-12 row full-content">
                <div class="col-lg-8">
                    <div class="stick">
                        <div class="block-content">
                            <h1 class="title">
                                <span>Gestión de pedidos</span>
                                <a
                                    href="#"
                                    v-b-modal.modal-dondeenviamos
                                    style="color: #029790; text-decoration: underline; font-size: 0.8em; padding-left: 1em"
                                    >¿A dónde enviamos?</a
                                >
                                <modal-block
                                    v-cloak
                                    title="¿A dónde enviamos?"
                                    desing="default"
                                    refer="dondeenviamos"
                                >
                                    De momento, Babyplant sólo realiza envíos a
                                    España Peninsular y las Islas Baleares*,
                                    excluyendo el archipiélago Canario, Ceuta y
                                    Melilla.<br /><br />
                                    Estamos trabajando para que esto sea posible
                                    en un futuro.
                                </modal-block>
                            </h1>

                            <load-spiner
                                v-if="!linesCompositeByWeeks"
                            ></load-spiner>
                            <div
                                v-else-if="!direcciones.length > 0"
                                class="col-12 main_content"
                            >
                                <div class="main_icon">
                                    <svg
                                        width="36"
                                        height="37"
                                        focusable="false"
                                        fill="currentColor"
                                        viewBox="0 0 48 48"
                                        aria-hidden="true"
                                    >
                                        <defs></defs>
                                        <g>
                                            <path
                                                d="M11.7 32H6v2h4.3a4.5 4.5 0 0 1 1.4-2z"
                                            ></path>
                                            <path
                                                d="M29 16v16H18.8a5.6 5.6 0 1 0 1 2h10a5.5 5.5 0 1 0 10.5 0H42v-9c0-9-13-9-13-9zM14.5 39a3.5 3.5 0 1 1 3.5-3.5 3.5 3.5 0 0 1-3.5 3.5zM35 39a3.5 3.5 0 1 1 3.5-3.5A3.5 3.5 0 0 1 35 39zm5-7h-.7a5.5 5.5 0 0 0-8.3-.3V18.1c3.2.4 9 1.8 9 6.9z"
                                            ></path>
                                            <path
                                                d="M27 29V10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v19a1 1 0 0 0 1 1h19a1 1 0 0 0 1-1zm-2-1H8V11h17z"
                                            ></path>
                                        </g>
                                    </svg>
                                </div>
                                <span class="text_alter">
                                    Todavía no tienes ninguna dirección. Empieza
                                    creando una.
                                </span>
                                <div class="bp-form-group">
                                    <b-button
                                        v-b-modal.modal-new-direccion
                                        class="alter-btn"
                                        @focus.prevent="$event.target.blur()"
                                    >
                                        <span>Añadir dirección</span>
                                    </b-button>
                                </div>

                                <address-create></address-create>
                            </div>
                            <div v-else>
                                <component-shipping-cart
                                    v-for="week in linesCompositeByWeeks"
                                    :ref="'shipBlock-' + week.weekYear"
                                    :key="week.weekYear"
                                    :week="week.weekYear"
                                    :direcciones="direcciones"
                                ></component-shipping-cart>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4">
                    <div class="stick">
                        <desglose-order-cart
                            :linesCompositeByWeeks="linesCompositeByWeeks"
                            :cart="cart"
                            :nextStepUrl="nextStepUrl"
                            :step="2"
                        ></desglose-order-cart>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["nextStepUrl", "cart", "weeks", "linesCompositeByWeeks"],
    data() {
        return {
            load_pedidos: true,
            direcciones: "",
            infoNeedCounter: []
        };
    },
    mounted() {
        this.loadAddressClient();

        this.$on("checkAllOrdersInfo", function(week) {
            this.checkAllOrdersInfo(week);
        });
        this.$on("loadAddressClient", function() {
            this.loadAddressClient();
        });

        ga("ec:setAction", "checkout", {
            step: 2
        });
        ga("send", "event", "Checkout", "Step 2");
    },
    methods: {
        checkAllOrdersInfo: function(week) {
            this.linesCompositeByWeeks.forEach(obj => {
                if (
                    obj.weekYear == week &&
                    !this.infoNeedCounter.includes(week)
                ) {
                    this.infoNeedCounter.push(week);
                }
            });
            this.$root.$emit("loadCartInfo");
        },
        responseNeedInfo: function() {
            Vue.toasted.show(
                "Indica toda la información de envio necesaria para continuar.",
                {
                    duration: 3000
                }
            );
        },
        loadAddressClient: function() {
            axios
                .get("/account/direccion/get-address")
                .then(response => {
                    this.direcciones = response.data.addresses;
                })
                .catch(e => {
                    console.log(e);
                });
        }
    }
};
</script>
